import { useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { authedAtTimestampAtom } from '../../auth/state';

export const useGetAuthedAtTimestamp = () => {
  const getAuthedAtTimestamp = useAtomCallback(useCallback((get) => get(authedAtTimestampAtom), []));
  const authedAtTimestamp = useAtomValue(authedAtTimestampAtom);

  return [authedAtTimestamp, getAuthedAtTimestamp];
};
